import "./Services.css";

import {
    PenTool,
    Box,
    Map,
    Layout,
    Tool,
    Truck
} from "react-feather";

const services = [
    {
        icon: <PenTool size={42} />,
        title: "Channel Letters",
        text: "Premium illuminated and non-illuminated channel letters for commercial storefronts."
    },
    {
        icon: <Box size={42} />,
        title: "Cabinet Signs",
        text: "Custom light boxes and cabinet signs manufactured for maximum visibility."
    },
    {
        icon: <Map size={42} />,
        title: "Pylon Signs",
        text: "Large freestanding signage solutions for shopping centres and commercial properties."
    },
    {
        icon: <Layout size={42} />,
        title: "Window Graphics",
        text: "Frosted films, printed graphics and vinyl applications for windows and glass."
    },
    {
        icon: <Tool size={42} />,
        title: "Custom Fabrication",
        text: "Precision fabrication using premium materials and modern manufacturing equipment."
    },
    {
        icon: <Truck size={42} />,
        title: "Installation",
        text: "Professional installation performed safely and efficiently by experienced crews."
    }
];

function Services() {

    return (

        <div className="services-container">

            <span className="section-tag">
                OUR SERVICES
            </span>

            <h2>
                Complete Signage Solutions
            </h2>

            <p className="services-intro">
                From concept to installation, we provide complete signage solutions
                tailored to businesses of every size.
            </p>

            <div className="services-grid">

                {services.map((service, index) => (

                    <div className="service-card" key={index}>

                        <div className="service-icon">
                            {service.icon}
                        </div>

                        <h3>{service.title}</h3>

                        <p>{service.text}</p>

                    </div>

                ))}

            </div>

        </div>

    );

}

export default Services;